import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  deleteSchoolLeaveDetail(context, payload) {
    ApiService.setHeader();
    return ApiService.delete("school/leave/management", {
      params: {
        id: payload,
      },
    }).then((response) => response);
  },
};

export default {
  actions,
};
